import { CirraServiceType } from '../enums/auth';

interface Route {
  path: string;
  label: string;
  SF_ORG_dependent: boolean;
  getUrl: () => string;
  children?: Record<string, Route>;
}

interface RouteWithChildren extends Route {
  children: Record<string, Route>;
}

interface AppRoutesType {
  home: Route;
  adminAgent: Route;
  promptLibrary: Route;
  changeRequests: Route;
  users: Route;
  organizations: Route;
  subscription: Route;
  settings: Route;
  pricing: Route;
  buyCredits: Route;
  mcp: Route;
  teamsSettings: Route;
  teamsSettingsCreate: Route;
}

const _generateUrlGetter = (path: string) => {
  return () => _concatHost(path);
};

const _AppRoutes: Record<
  string,
  Omit<Route, 'getUrl'> & { getUrl?: () => string }
> = {
  home: {
    path: '/',
    label: 'MCP Management',
    SF_ORG_dependent: true,
  },
  adminAgent: {
    path: '/admin-agent',
    label: 'Admin Agent',
    SF_ORG_dependent: true,
  },
  promptLibrary: {
    path: '/prompt-library',
    label: 'Prompt Library',
    SF_ORG_dependent: false,
  },
  changeRequests: {
    path: '/change-requests',
    label: 'Change Agent',
    SF_ORG_dependent: true,
  },
  users: {
    path: '/users',
    label: 'Users',
    SF_ORG_dependent: false,
  },
  organizations: {
    path: '/organizations',
    label: 'Organizations',
    SF_ORG_dependent: false,
  },
  subscription: {
    path: '/subscription',
    label: 'Subscription',
    SF_ORG_dependent: false,
  },
  settings: {
    path: '/admin-agent/settings',
    label: 'Settings',
    SF_ORG_dependent: false,
  },
  pricing: {
    path: '/pricing',
    label: 'Pricing',
    SF_ORG_dependent: false,
  },
  buyCredits: {
    path: '/buy-credits',
    label: 'Buy Credits',
    SF_ORG_dependent: false,
  },
  mcp: {
    path: '/',
    label: 'MCP Management',
    SF_ORG_dependent: true,
  },

  // Settings routes
  teamsSettings: {
    path: '/settings/teams',
    label: 'Teams',
    SF_ORG_dependent: false,
  },
  teamsSettingsCreate: {
    path: '/settings/teams/create',
    label: 'Create Team',
    SF_ORG_dependent: false,
  },
};
// Add getUrl method to each route
Object.keys(_AppRoutes).forEach((key) => {
  const route = _AppRoutes[key as keyof AppRoutesType];
  route.getUrl = _generateUrlGetter(route.path);
});

const _concatHost = (path: string) => {
  const url = window.location.origin + path;
  // Remove trailing slash if it exists
  return url.endsWith('/') ? url.slice(0, -1) : url;
};

export const AppRoutes = _AppRoutes as unknown as AppRoutesType;

export const getServiceHomeUrl = (service: CirraServiceType) => {
  return getServiceHomePath(service).getUrl();
};

export const getServiceHomePath = (service: CirraServiceType) => {
  return service === CirraServiceType.AGENTS
    ? AppRoutes.adminAgent
    : AppRoutes.home;
};

export const getTeamRoute = (teamId: string): RouteWithChildren => {
  const teamPath = `/teams/${teamId}`;
  const accessUsersPath = `${teamPath}/access/users`;
  return {
    path: teamPath,
    label: `Team ${teamId}`,
    SF_ORG_dependent: false,
    getUrl: _generateUrlGetter(teamPath),
    children: {
      accessUsers: {
        path: accessUsersPath,
        label: 'Users',
        SF_ORG_dependent: false,
        getUrl: _generateUrlGetter(accessUsersPath),
      },
    },
  };
};
